import { useCallback } from 'react';

import qs from 'qs';

import { useNavigate } from '@change-corgi/core/react/router';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';

import type { ShareChannel } from '../../types';

export function useRedirect() {
	const {
		data: {
			initial,
			petition: { slug },
		},
	} = usePsfSharePageData();
	const navigate = useNavigate();
	const shortDisplayName = useQueryParamValue('short_display_name');
	const sourceLocation = useQueryParamValue('source_location');
	const allowActions = useQueryParamValue('allow_actions');
	const guest = useQueryParamValue('guest');
	const {
		userAgent: { isWebview },
	} = useUtilityContext();

	return useCallback(
		(channel: ShareChannel) => {
			// webviews do not allow opening in new tab, which most share actions attempt to do
			// instead they attempt to open in the current tab, which if overridden by this redirect
			// so this disables the redirect in order to be able to share
			if (channel === 'copy' || isWebview) return;

			if (initial) {
				navigate(
					`/p/${encodeURIComponent(slug)}/psf/share${qs.stringify(
						{
							share: 1,
							...(shortDisplayName && { short_display_name: shortDisplayName }),
							...(sourceLocation && { source_location: sourceLocation }),
							...(allowActions && { allow_actions: allowActions }),
						},
						{ addQueryPrefix: true },
					)}`,
					{
						// forcing external mode to prevent a client-side routing on the same path
						// which would result in a loading state and a non-reset page state
						// TODO rework the PSF share urls to use different paths
						forceMode: 'external',
					},
				);
				return;
			}

			navigate(
				`/p/${encodeURIComponent(slug)}/d${qs.stringify(
					{
						source_location: 'combo_psf',
						...(['new', 'existing'].includes(guest || '') ? { from_guest_psf: '1' } : undefined),
					},
					{ addQueryPrefix: true },
				)}`,
			);
		},
		[initial, shortDisplayName, sourceLocation, allowActions, guest, slug, navigate, isWebview],
	);
}
